import React from "react";
import styles from "./fields.module.css";

export interface SelectFieldProps {
  id?: string;
  label: string;
  value: string;
  options: Array<{ label: string; value: string }>;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  icon?: React.ReactNode;
}

export const SelectField: React.FC<SelectFieldProps> = ({
  id,
  label,
  value,
  options,
  onChange,
  onBlur,
  placeholder,
  required,
  disabled,
  error,
  icon,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  const selectClassName = `${styles.select} ${icon ? styles.inputWithIcon : ""} ${error ? styles.inputError : ""}`;

  return (
    <div className={styles.container}>
      <label className={styles.label} htmlFor={id}>
        {label} {required && <span className={styles.required}>*</span>}
      </label>
      <div className={styles.inputWrapper}>
        {icon && <span className={styles.iconPrefix}>{icon}</span>}
        <select
          id={id}
          className={selectClassName}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          required={required}
          disabled={disabled}
          aria-label={label}
        >
          {placeholder && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};
